export const general = {
    class: "Class",
    professor: "Professor",
    description: "Description",
    grade: "Grade",
    load: "Load",
    speech: "Speech",
    upload: "Upload",
    numClasses: "Lec. Hours",
    numLabs: "Lab Hours",
    credit: "Credits",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    hours: "Hours",
    minutes: "Min",
    seconds: "Sec",
    am: "AM",
    pm: "PM",
    year: "year",
    room: "Room",
    language: "Language",
    limit: "Limit",
    exam: "Exam",
    completedCourse: "Completed",
    wishlist: "Wishlist",
    offline: {
        title: "Connection Failed",
        description:
            "Unable to connect to server. Please check your internet connection.",
        goHome: "Go Home",
        retry: "Retry",
        banner: "You are offline. Only data loaded in this session is available.",
        navDisabled: "Not available in offline mode",
    },
    serverError: {
        title: "Server Error",
        apology: "We apologize for the inconvenience",
        description: "The server is experiencing issues. Please try again later.",
        goHome: "Go Home",
        retry: "Retry",
    },
    notFound: {
        title: "Page Not Found",
        description: "The page you are looking for does not exist or has been moved.",
        goHome: "Go Home",
    },
    toOTLV3: "Previous",
}
